import { render, staticRenderFns } from "./StaffReplacementModal.vue?vue&type=template&id=712399a5&scoped=true"
import script from "./StaffReplacementModal.vue?vue&type=script&lang=js"
export * from "./StaffReplacementModal.vue?vue&type=script&lang=js"
import style0 from "./StaffReplacementModal.vue?vue&type=style&index=0&id=712399a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712399a5",
  null
  
)

export default component.exports